import { useEffect,useState } from "react";

export const useSession = () => {
  const [session, setSession] = useState<string | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    try {
      const storedSession = localStorage.getItem("session");
      setSession(storedSession);
    } catch (err) {
      setError(
        err instanceof Error ? err : new Error("Failed to read session"),
      );
    }
  }, []);

  const updateSession = (newSession: string) => {
    try {
      localStorage.setItem("session", newSession);
      setSession(newSession);
    } catch (err) {
      setError(
        err instanceof Error ? err : new Error("Failed to update session"),
      );
    }
  };

  const clearSession = () => {
    localStorage.removeItem("session");
    setSession(null);
  };

  const logout = (path?: string) => {
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();
    // Redirect to root path
    window.location.href = path || "/";
  };

  return {
    session,
    error,
    updateSession,
    clearSession,
    isAuthenticated: !!session,
    logout,
  };
};
